package dev.lingvo.site.components.studio.editor

import androidx.compose.runtime.Composable
import dev.lingvo.site.i18n.t
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text

/** Only existing slot captures, project artwork and built-in shapes enter the editor. */
@Composable
internal fun AssetsPanel(state: StudioUiState, dispatch: (StudioIntent) -> Unit) {
    Div { Text(t("studio.editor.assets_panel.assets", "Assets"))
        state.assets.forEach { asset -> StudioButton(asset.label, state.editable) { dispatch(StudioIntent.Add("asset", asset)) }; Text(asset.status) }
        StudioButton(t("studio.editor.assets_panel.add_rectangle", "Add rectangle"), state.editable) { dispatch(StudioIntent.Add("rectangle")) }
        StudioButton(t("studio.editor.assets_panel.add_badge", "Add badge"), state.editable) { dispatch(StudioIntent.Add("badge")) }
        StudioButton(t("studio.editor.assets_panel.add_logo", "Add logo"), state.editable && state.document.brand.logoAssetId != null) { dispatch(StudioIntent.Add("logo")) }
    }
}
